import { Theme } from "@mui/material";
import { CustomAccordionType } from "./types";

const getPrimaryTypeStyles = (theme: Theme) => ({
  borderRadius: "12px",
  "&:last-of-type": {
    borderRadius: "12px",
  },
  "&:first-of-type": {
    borderRadius: "12px",
  },
  "& .MuiAccordionSummary-root": {
    paddingY: "12px",
    paddingX: { xs: "16px", md: "24px" },
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: theme.palette.common.black,
    "&.Mui-expanded": {
      color: theme.palette.primary.main
    }
  },
  "& .MuiAccordionDetails-root": {
    paddingY: "0px",
    paddingX: { xs: "16px", md: "24px" }
  }
});

const getSecondaryTypeStyles = () => ({
  borderRadius: { xs: "12px", md: "20px" },
  "&:last-of-type": {
    borderRadius: { xs: "12px", md: "20px" },
  },
  "&:first-of-type": {
    borderRadius: "12px",
  },
  "& .MuiAccordionSummary-root": {
    padding: { xs: "4px 16px", md: "20px 32px" },
  },
  "& .MuiAccordionDetails-root": {
    paddingY: "0px",
    paddingX: { xs: "16px", md: "32px" }
  }
});

export const getStyles = (type: CustomAccordionType, theme: Theme) => {
  let styles = {
    accordion: {
      boxShadow: "none",
      border: "1px solid #E4E5E9",
      "&.Mui-expanded": {
        borderColor: theme.palette.primary.main
      },
      "&:before": {
        height: "0px"
      },
      "& .MuiAccordionSummary-content": {
        alignItems: "center",
        fontSize: { xs: "1.125rem", md: "1.25rem" },
        fontWeight: "700",
        "& svg": {
          marginRight: "12px",
          width: "32px",
          height: "32px",
          color: theme.palette.primary.main
        }
      }
    },
    box: {}
  };
  switch (type) {
    case "primary":
      styles.accordion = { ...styles.accordion, ...getPrimaryTypeStyles(theme) };
      styles.box = {
        borderTop: "1px solid #E4E5E9",
        paddingY: "24px"
      };
      break;
    case "secondary":
      styles.accordion = { ...styles.accordion, ...getSecondaryTypeStyles() };
      styles.box = {
        paddingBottom: { xs: "16px", md: "32px" }
      };
      break;
  };
  return styles;
}